import _ from "lodash";
import moment from "moment";
import pendency, {
  InitLastPendency,
  Pendency,
  SendPendencyAsync,
} from "./pendency";
import http from "../utils/api";
import formatDate from "../utils/formatDate";
import { getHorasMes, initSystem } from "../provider/system.service";
import { resolveDate, resolveDateDivider } from "../utils/dateUtils";
import { getCurrentTOTP } from "../utils/totpGenerator";
import localforage from "../utils/localforage";
import processHoursPerDay from "../components/hooks/processHoursPerDay";

class Player {
  pendency;
  db;
  notification;
  history;
  setPendency;
  listTempPendency;
  setListTempPendency;
  dbPlayer;
  dbTemp;
  playerSubs;
  tempSubs;
  timePerDay = [];

  async initialize() {
    if (navigator.online) await initSystem();
    if (this.playerSubs) {
      this.tempSubs();
      this.playerSubs();
    }
    if (!navigator.onLine) {
      this.dbPlayer.get({ source: "cache" }).then((doc) => {
        if (!doc.exists) this.setPendency(doc.data());
      });
    } else
      this.dbPlayer
        .get()
        .then((doc) => {
          if (!doc.exists) {
            http
              .get("apontamentos/ultimo")
              .then(async ({ data }) => {
                const player = { ...(await new InitLastPendency(data.data)) };
                player.dataHoraInicio = null;
                player.dataHoraFim = null;
                doc.ref.set(player);
              })
              .catch(() => {
                doc.ref.set({ ...new Pendency() });
              });
          }
        })
        .catch(console.log);

    this.playerSubs = this.dbPlayer.onSnapshot(
      { includeMetadataChanges: true },
      (doc) => {
        if (!_.isEqual(this.pendency, doc.data())) {
          this.setPendency(doc.data());
        }
      },
      () => {}
    );
    this.tempSubs = this.dbTemp.onSnapshot(
      { includeMetadataChanges: true },
      (doc) => {
        const docs = doc.docs.map((document) => {
          return document.data();
        });
        if (!_.isEqual(docs, this.listTempPendency)) {
          this.setListTempPendency(docs);
        }
      },
      () => {}
    );
    if (
      this?.pendency?.dataHoraInicio &&
      moment(this?.pendency?.dataHoraInicio).isBefore(
        moment().hour(0).minute(0).second(0)
      )
    ) {
      this.playPause(
        true,
        moment(this.pendency.dataHoraInicio).hour(23).minute(59)
      );
    }
  }

  selectPendency = (pendency) => {
    let newPendency = { ...new Pendency(), pendenciaId: "", ...pendency };
    newPendency.dataHoraInicio = this.pendency?.dataHoraInicio;
    newPendency.dataHoraFim = this.pendency?.dataHoraFim;
    newPendency.status = null;
    newPendency.requestMessage = null;
    this.dbPlayer.update(newPendency).then(() => {
      this.notification.notify({
        message: "Pendência salva na área de transferência",
        color: "success",
      });
    });
  };

  ChangePendency = (data, values) => {
    this.selectPendency(values);
  };

  erasePendency = () => {
    const { dataHoraInicio, dataHoraFim } = this.pendency;
    const Pendency = { ...pendency, dataHoraInicio, dataHoraFim };
    this.dbPlayer.update(Pendency);
  };

  push(cb = () => {}) {
    this.dbTemp
      .doc(formatDate(this.pendency.dataHoraInicio))
      .set(this.pendency)
      .then(() => {});
    return cb();
  }

  async add(pendency) {
    pendency = await resolveDate(pendency);
    const { dataHoraInicio = moment() } = pendency;
    if (!moment(pendency.dataHoraFim).isValid()) pendency.dataHoraFim = null;
    this.dbTemp
      .doc(formatDate(dataHoraInicio))
      .set({ ...(await SendPendencyAsync(pendency)) })
      .then(() => {});
  }

  clearDateTime() {
    this.dbPlayer.update({
      dataHoraInicio: null,
      dataHoraFim: null,
    });
  }

  getTimePerDay = (obj, day) => obj[day]?.total || 0;
  getObjTimePerDay = (obj, day) => obj[day];

  async setSelecteds(selecteds) {
    await this.dbPlayer.get().then((doc) => {
      this.listTempPendency
        .filter((item) => selecteds.includes(formatDate(item.dataHoraInicio)))
        .forEach((pendency) => {
          this.dbTemp.doc(formatDate(pendency.dataHoraInicio)).update({
            ...doc.data(),
            dataHoraInicio: pendency.dataHoraInicio,
            dataHoraFim: pendency.dataHoraFim,
          });
        });
    });
  }

  async sendPendencies(selecteds) {
    const sortSelecteds = selecteds.sort((a, b) => moment(a).diff(b));
    await http
      .get("apontamentos", {
        params: {
          dataHoraInicio: formatDate(
            moment(sortSelecteds[0]).set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0,
            })
          ),
        },
      })
      .then(async (dados) => {
        const arrayRangeDate = dados?.data?.data?.map((a) => a.dataHoraInicio);
        await this.listTempPendency
          .filter((item) => selecteds.includes(formatDate(item.dataHoraInicio)))
          .map(async (pendency) => {
            const conflict = arrayRangeDate.includes(
              formatDate(pendency.dataHoraInicio)
            );
            const formatedData = moment(pendency.dataHoraInicio).format(
              "DD/MM HH:mm"
            );

            if (
              conflict &&
              !window.confirm(
                `Um apontamento no horário "${formatedData}" já existe!\nDeseja substituir?`
              )
            ) {
              this.dbTemp.doc(formatDate(pendency.dataHoraInicio)).update({
                status: "alert",
                requestMessage: "Conflito de horário.",
              });
              return;
            }
            await http
              .post(
                "apontamentos",
                { ...(await SendPendencyAsync(pendency)), inserting: true },
                { headers: { "X-Application-Totp": getCurrentTOTP() } }
              )
              .then(
                ({ data: { data, error } }) => {
                  if (!error && data) {
                    this.dbTemp
                      .doc(formatDate(pendency.dataHoraInicio))
                      .delete();
                  }
                },
                (err) => {
                  this.dbTemp.doc(formatDate(pendency.dataHoraInicio)).update({
                    status: "error",
                    requestMessage:
                      err.response?.data?.error?.description ??
                      "Erro desconhecido",
                  });
                }
              );
          });
      })
      .finally(async () => await getHorasMes({}));
  }

  removeSelecteds = async (selecteds) => {
    await selecteds.forEach((item) => {
      let doc = this.dbTemp.doc(formatDate(item));
      doc.delete().then();
    });
  };

  changePendencyWithDate = async (initialValues, pendency) => {
    pendency = await resolveDate(pendency);
    if (moment(pendency.dataHoraInicio).isSame(pendency.dataHoraFim)) {
      return this.dbTemp
        .doc(formatDate(initialValues.dataHoraInicio))
        .delete()
        .then(() => {});
    } else if (
      !moment(initialValues.dataHoraInicio).isSame(pendency.dataHoraInicio)
    ) {
      this.dbTemp
        .doc(initialValues.dataHoraInicio)
        .delete()
        .then(async () => {
          pendency.status = null;
          pendency.requestMessage = null;
          await this.dbTemp.doc(pendency.dataHoraInicio)?.set(pendency);
        });
    } else {
      if (!pendency.pendenciaId) pendency.pendenciaId = null;
      pendency.status = null;
      pendency.requestMessage = null;
      if (pendency?.caminhoArquivo === undefined)
        pendency.caminhoArquivo = null;
      this.dbTemp
        .doc(initialValues.dataHoraInicio)
        .update({ ...pendency })
        .then(() => {});
    }
  };
  splitPendency = async (initialValues, pendency) => {
    const divider = resolveDateDivider(pendency);
    pendency = await resolveDate(pendency);

    this.dbTemp
      .doc(initialValues.dataHoraInicio)
      .update({ ...pendency, dataHoraFim: divider })
      .then(async () => {
        await this.dbTemp
          .doc(divider)
          ?.set({ ...pendency, dataHoraInicio: divider });
      });
  };

  filterDates() {
    return processHoursPerDay();
  }

  async setProps(props) {
    Object.assign(this, props);
    this.initialize();
    /* if(!pendency){
            http.get('apontamentos/ultimo').then(({data}) => {
                console.log('apontamentos/ultimo', data.data)
                this.setPendency({...new InitLastPendency(data.data)});
                this.selectPendency({...new InitLastPendency(data.data)})
            }).catch(() => {
                this.setPendency({...new Pendency()});
                this.selectPendency({...new Pendency()})
            })
        }*/
  }
}

export default new Player();
